module.exports = __webpack_public_path__ + "static/media/Bell_beaker_mba_wales.6107957c.png";